import { BASE_URL } from '../API/BASE_URL';

export const getVoises = async () => {
  const response = await fetch(BASE_URL + 'voiceover/', {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
